import { createUseConnectionStateHook } from 'use-connection-state'

const useConnectionState = createUseConnectionStateHook({
	endpoints: ['/'],
})

export const useIsOnline = () => useConnectionState() === 'online'
